var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bt-forgot"},[_vm._v(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic vitae reiciendis, quo nulla quod eveniet tempora? Veritatis aliquid libero nostrum cumque ut voluptatibus. Veritatis reprehenderit commodi praesentium neque dignissimos aliquam? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }